export function cameraRequestHeaders(etag) {
  const value = String(etag || '').trim();
  return value ? { 'If-None-Match': value } : {};
}

export function cameraRefreshDelay({
  unchangedCount = 0,
  ready = false,
  failed = false,
  hidden = false,
} = {}) {
  if (hidden) return 5000;
  if (failed) return 2200;
  const base = ready ? 900 : 650;
  return Math.min(4000, Math.round(base * (1.45 ** Math.max(0, unchangedCount))));
}

export function isCameraAbort(error) {
  return String(error?.name || '') === 'AbortError';
}

export function newCameraViewerId(cryptoApi = globalThis.crypto) {
  if (typeof cryptoApi?.randomUUID === 'function') {
    return cryptoApi.randomUUID().replaceAll('-', '');
  }
  if (typeof cryptoApi?.getRandomValues === 'function') {
    const bytes = new Uint8Array(16);
    cryptoApi.getRandomValues(bytes);
    return Array.from(bytes, (value) => value.toString(16).padStart(2, '0')).join('');
  }
  return `viewer${Date.now().toString(36)}${Math.random().toString(36).slice(2, 14)}`;
}
